import fr from './lang/fr';
import en from './lang/en';

export default { en: en, fr: fr };